import { useState } from 'react'

import classNames from 'classnames'

import Field from 'components/Field'
import Icon from 'components/Icon'

import style from './index.module.scss'

const Password = ({
  data,
  placeholder,
  onChange,
  classes = null,
  isDisabled = false,
  isRequired = false,
}) => {
  const [show, setShow] = useState(false)

  return (
    <div
      className={
        classNames(
          style.block,
          classes && classes.map(el => style[el] || el),
        )
      }
    >
      <Field
        type={show ? 'text' : 'password'}
        placeholder={placeholder}
        data={data}
        onChange={onChange}
        isDisabled={isDisabled}
        isRequired={isRequired}
      />
      <button
        type={'button'}
        className={style.eye}
        onClick={() => setShow(!show)}
        aria-label={'Toggle password visibility'}
      >
        <Icon
          name={show ? 'icon-toggle-view' : 'icon-toggle-view-off'}
          size={'sm'}
        />
      </button>
    </div>
  )
}

export default Password
